import React from "react";
import "./index.css";
import { Link } from "react-router-dom";

const Send = () => {
  return (
    <div className="container-lg send">
      <div className="containerPop activePop">
        <div className="flex flexRow">
          <div className="textCol flex flexCol alignCenter">
            <h1 className="relative ">
              <span>Tu solicitud fué recibida</span>
            </h1>
            <h3>
              Nuestros especialistas están buscando las mejores opciones y propuestas, en minutos nos contactaremos.
            </h3>
            <iframe className="sendIframe" width="560" height="315" src="https://www.youtube.com/embed/S2B2pBa5qOc?si=kkpf4RV17Uzu47rk" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            <Link className="btn btn-primary" to="/">
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Send;
